export const MULTI_SELECT_EMPTY_VALUE = [];
export const SINGLE_SELECT_EMPTY_VALUE = '';
export const SELECT_INTERNAL_DUMMY_TITLE = 'awbfhaba_SPT_EMPTY_xxx';
export const MAXIMUM_PARTIAL_VISIBLE_ITEMS_LENGTH = 5;
